import { ProductType } from 'cart-model';

export const PRODUCT_TYPE_MAPPING: Record<ProductType, string> = {
  [ProductType.funds]: 'investment fund',
  [ProductType.ike]: 'ike',
  [ProductType.ikze]: 'ikze',
};
